import { render } from "./AlertInfo.vue?vue&type=template&id=f68573b2&ts=true"
import script from "./AlertInfo.vue?vue&type=script&lang=ts"
export * from "./AlertInfo.vue?vue&type=script&lang=ts"

import "./AlertInfo.vue?vue&type=style&index=0&id=f68573b2&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__